// handling special characters
export var SPECIALCHAR = {
  ' ': true,
  '(': true,
  ')': true,
  ',': true,
  '/': true,
  '-': true
}; // When adding more words in lower & upper object, make sure
// it should be titleCase
// All prepositions should be left lowercase

export var LOWERCASEWORDS = {
  A: true,
  The: true,
  In: true,
  To: true,
  For: true,
  And: true,
  Of: true
}; // Certain words such as country shortname or acronyms should be left uppercase

export var UPPERCASEWORDS = {
  Us: true,
  Ap: true,
  Ib: true,
  Pltw: true
};